// Zeus (its page, its side panel, its cards, its projects, its sharing) and
// conversations (the page, the dock, a conversation's window).
export default {
  sousTitre: 'Orion’s assistant',
  nouvelleConversation: 'New conversation',
  rechercher: 'Search',
  rechercherConversation: 'Search conversations',
  colonne: { projets: 'Projects', taches: 'Tasks', etudes: 'Studies', epinglees: 'Pinned', recentes: 'Recents', epingler: 'Pin “{titre}”', desepingler: 'Unpin “{titre}”', chercherPartout: 'Search your chats', chercher: 'Search', aucunProjet: 'No project yet: a project gathers chats and documents, with an instruction Zeus reads in each of them.', nbConversations: 'no chat | 1 chat | {n} chats' },
  etudes: { nouvelle: 'New study', vide: 'Your studies will appear here. Ask Zeus for one, or set it up yourself.', enCours: 'In progress', echec: 'Stopped' },
  projets: 'Projects',
  nouveauProjet: 'New project',
  nomProjet: 'Project name',
  nomNouveauProjet: 'New project name',
  vosConversations: 'Your conversations',
  lecture: 'Loading…',
  apparaitront: 'Your conversations with Zeus will appear here.',
  aucuneCorrespond: 'No matches.',
  nouveauTitre: 'New title',
  partageeEquipe: 'Shared with the team',
  partageePersonnes: 'Shared with selected people',
  renommer: 'Rename: {titre}',
  confirmerEffacement: 'Confirm deletion: {titre}',
  effacerTitre: 'Delete: {titre}',
  partageesAvecVous: 'Shared with you',
  unMembre: 'A team member',
  rangerProjet: 'Move to a project',
  aucunProjet: 'No project',
  imaginer: 'What would you like to imagine?',
  aRemarque: 'Zeus noticed',
  seRelit: 'Reloading the conversation…',
  vous: 'You',
  reflechit: 'Zeus is thinking…',
  reflechitNom: '{nom} is thinking…',
  cartes: {
    creerFormat: 'Create this format',
    creerFormatMessage: 'Create the format ‘{titre}’',
    eprouverTitres: 'Test these titles',
    eprouverTitre: 'Test this title',
    comparables: 'Comparable programmes',
    programme: 'Programme',
    diffuse: 'Aired',
    partAudience: 'Audience share',
    telespectateurs: 'Viewers',
  },
  panneau: {
    partagee: 'Shared',
    pleinePage: 'Full page',
    reduire: 'Minimise',
    fermer: 'Close',
  },
  partage: {
    prive: 'Private',
    equipe: 'The whole team',
    personnes: 'Selected people',
    partageEquipe: 'Shared with the team',
    partageAvec: 'Shared with {n} people | Shared with {n} person | Shared with {n} people',
    partager: 'Share',
    auMoinsUne: 'Choose at least one person.',
    avecQui: 'Share with',
    rechercherPersonne: 'Search for a person',
    lectureEquipe: 'Loading the team…',
    personneDautre: 'No one else in your team yet.',
    annuler: 'Cancel',
    enregistrer: 'Save',
  },
  projet: {
    seLit: 'Loading the project…',
    nom: 'Project name',
    renommer: 'Rename the project',
    confirmer: 'Confirm',
    effacer: 'Delete',
    consigne: 'Instructions for Zeus',
    gardee: 'Saved',
    consignePlaceholder: 'What Zeus needs to know for this project: the programme, the target audience, the tone, what to avoid…',
    consigneAria: 'Instructions for Zeus on this project',
    documents: 'Project documents',
    envoi: 'Uploading…',
    deposer: 'Upload a file',
    coller: 'Paste a text',
    sonTitre: 'Its title',
    titreTexte: 'Text title',
    textePlaceholder: 'The text to keep in the project',
    texteAria: 'The text',
    annuler: 'Cancel',
    garder: 'Keep this text',
    aucunDocument: 'No documents yet.',
    illisible: 'Unreadable',
    lectureEnCours: 'Reading…',
    retirer: 'Remove: {titre}',
    conversations: 'Project conversations',
    aucuneConversation: 'No conversations yet.',
  },
  saisie: {
    prepare: 'A reply is on its way…',
    demandez: 'Ask Zeus…',
    aria: 'Your message to Zeus',
    demandezNom: 'Ask {nom}…',
    ariaNom: 'Your message to {nom}',
    envoyer: 'Send',
  },
  actions: {
    formatCree: 'Format created: ‘{titre}’',
    ficheCompletee: 'Format sheet completed: ‘{titre}’',
    ficheCompleteeChamps: 'Format sheet completed: ‘{titre}’ ({champs})',
    sonarPrepare: 'Question prepared: ‘{question}’',
    panelEtude: 'The study panel: ‘{libelle}’',
    ouvrir: 'Open',
    ouvrirSonar: 'Open the Sonar',
    ouvrirExplorer: 'Open Explore',
    interroger: 'Ask',
    tacheProposee: 'Task proposed: ‘{titre}’, {cadence}',
    voirTache: 'Review and activate',
  },
  voix: {
    parler: 'Talk to Zeus',
    arreter: 'Stop',
    vous: 'You',
    etat: {
      arret: 'Stopped',
      connexion: 'Connecting…',
      ecoute: 'Listening',
      parle: 'Zeus is speaking (interrupt him anytime)',
      cherche: 'Zeus is looking in Orion…',
      erreur: 'Voice conversation interrupted',
    },
  },
  champs: {
    titre: 'the title',
    logline: 'the logline',
    promesse: 'the promise',
    genre: 'the genre',
    diffuseur: 'the broadcaster',
    case_horaire: 'the slot',
    cible: 'the target',
    cibles: 'the targets',
  },
  questionTitre: 'Does the title {titre} make you want to watch this programme?',
  questionTitres: 'Which of these titles makes you most want to watch this programme: {liste} or {dernier}?',
  guillemets: '‘{x}’',
  departs: {
    nouveauFormat: 'I have a new format: help me find a title for it',
    samedi: 'What works on Saturday nights with 25-49s?',
    monte: 'What’s rising across my territories this week?',
    rendezVous: 'Which events are coming up in my territories?',
    sonar: 'What are the key takeaways from our latest study?',
    dossiers: 'Where do my projects stand?',
    jeunes: 'What’s rising right now with 15-34s?',
  },
  nombre: {
    pc: '{v}%',
    millions: '{v}m',
  },
  conversations: {
    titre: 'Conversations',
    sousTitre: 'All your conversations, to reread or resume',
    toutes: 'All',
    genres: {
      sonar: 'Study panel',
      persona: 'Audience persona',
      marque: 'Brand persona',
      jumeau: 'Project twin',
      zeus: 'Zeus',
      polis: 'Voters of a wave',
    },
    periodes: {
      aujourdhui: 'Today',
      hier: 'Yesterday',
      semaine: 'This week',
      mois: 'This month',
      avant: 'Earlier',
    },
    seLisent: 'Loading conversations…',
    aucune: 'No conversations yet.',
    aucuneCorrespond: 'No conversation matches.',
    partageeEquipe: 'Shared with the team',
    partageeAvec: 'Shared with {n} people | Shared with {n} person | Shared with {n} people',
    reprendre: 'Resume',
    pageOrigine: 'Original page',
    confirmer: 'Confirm',
    effacer: 'Delete',
    aucunMessage: 'No messages.',
    reponseSePrepare: 'A reply is on its way.',
    seLit: 'Loading the conversation…',
    choisir: 'Choose a conversation to reread.',
    reduireTitre: 'Minimise: {titre}',
    ouvrirTitre: 'Open: {titre}',
    fermerTitre: 'Close: {titre}',
    nouvelle: 'New conversation',
    ouvrirOrigine: 'Open the original page',
    reduire: 'Minimise',
    fermer: 'Close',
    toutLePanel: 'The whole panel',
    territoire: 'Territory',
    tousTerritoires: 'All territories',
    jury: 'The judges',
    envieAvec: 'Want to watch with {jury}',
    leurReponse: 'Their answer',
    quelleQueSoit: 'Whatever their answer',
    ontRepondu: 'Who answered ‘{reponse}’',
    quiAiment: 'Fans of',
    quelsQueSoient: 'Whatever their tastes',
    donnent8: 'Who rate {nom} 8 or more',
    pourCommencer: 'To get started',
    panelReflechit: 'The panel is thinking…',
    electeursReflechissent: 'The voters are thinking…',
    reflechit: '{prenom} is thinking…',
    posezLeur: 'Ask them a question…',
    demandezLui: 'Ask them…',
    envoyer: 'Send',
    cibles: {
      c4plus: '4+',
      c4a14: '4-14s',
      c15a34: '15-34s',
      c25a49: '25-49s',
      frda50: 'FRDA-50',
      c50plus: 'Over-50s',
    },
    segment: {
      cibles: {
        c4plus: 'Viewers aged 4+',
        c4a14: '4-14s',
        c15a34: '15-34s',
        c25a49: '25-49s',
        frda50: 'FRDA-50',
        c50plus: 'Over-50s',
      },
      toutLePanel: 'The whole panel',
      jury: 'who would want to watch with {jury}',
      reponse: 'who answered ‘{reponse}’',
      fan: 'who rate {nom} 8 or more',
    },
    juryDerniereSaison: 'last season’s judges',
    questionsSonar: {
      departage1: 'What makes you want to watch with these judges?',
      departage2: 'Who would you miss on this judging panel?',
      departage3: 'Who would you replace, and with whom?',
      fan1: 'Why {nom}?',
      fan2: 'What do you know about {nom} at the moment?',
      fan3: 'What if {nom} were not there?',
      choix1: 'What mattered most in your answer?',
      choix2: 'What would change your mind?',
      choix3: 'What are people around you saying about it?',
      defaut1: 'What would make you watch the next season?',
      defaut2: 'Which name would make you switch over?',
      defaut3: 'What do you expect from this programme?',
    },
    personaDe: '{marque} persona',
    jumeau: 'Twin · {segment}',
  },
}
